import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tree } from 'primereact/tree';
import { Col } from "react-bootstrap";
import { ProgressBar } from 'primereact/progressbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Langs from "../../app/lang/langs";
import styles from './VcompCompnents.module.css';

const ORANGE = "#FF9015";

const getColor = (num) => {
    if (num < 0 || num > 100) return '#9ca3af';
    if (num < 25) return '#ef4444';
    if (num < 50) return ORANGE;
    if (num < 75) return '#eab308';
    return '#22c55e';
};

export default function ProgressViewCollab(props) {
    const isMobile = useSelector((state) => state.settings.isMobile);

    const [nodes, setNodes] = useState([]);
    const [localProg, setLocalProg] = useState(0);
    const [expandedKeys, setExpandedKeys] = useState({});

    const collectAllKeys = (nodeList) => {
        let keys = {};
        (nodeList || []).forEach(node => {
            if (node.children && node.children.length > 0) {
                keys[node.key] = true;
                Object.assign(keys, collectAllKeys(node.children));
            }
        });
        return keys;
    };

    const expandAll = () => {
        setExpandedKeys(collectAllKeys(nodes));
    };

    const collapseAll = () => {
        setExpandedKeys({});
    };

    useEffect(() => {
        if (props.nodes && props.nodes.length > 0) {
            if (props.nodes?.length > 0) {
                const excludedKeys = [];
                const processNode = (node) => {
                    const keyPrefix = node.scope === 'category' ? 'cat' :
                        node.scope === 'subcategory' ? 'subcat' : 'apt';
                    const key = `${keyPrefix}-${node.id}`;
                    let processedChildren = node.children ? node.children.map(processNode).filter(child => child !== undefined) : [];
                    if ((keyPrefix === 'cat' || keyPrefix === 'subcat') && processedChildren.length === 0) {
                        return undefined;
                    }
                    if (!excludedKeys.includes(key)) {
                        return {
                            key: key,
                            id: node.id,
                            label: node.nom,
                            progress: node.progress * 20,
                            coef: node.coef,
                            className: node.scope,
                            pos: node.pos,
                            visibility: node.visibility,
                            description: node.description,
                            type: node.type,
                            aspect: node.aspect ? node.aspect : null,
                            collabs_answers: node.collabs_answers ? node.collabs_answers : [],
                            collabs_no_answers: node.collabs_no_answers ? node.collabs_no_answers : [],
                            children: node.children ? node.children.map(child => processNode(child)).filter(child => child !== undefined) : []
                        };
                    }
                };

                const sdata = props.nodes.map(category =>
                    processNode(category)
                );
                const categories = filterByCollabIdAndRecalculateScores(sdata);
                const totalCoef = categories.reduce((acc, cat) => acc + (cat.coef || 1), 0);
                const weightedSum = categories.reduce((acc, cat) => acc + ((cat.progress || 0) * (cat.coef || 1)), 0);
                const averageProgress = totalCoef > 0 ? weightedSum / totalCoef : 0;
                setLocalProg(parseFloat(averageProgress).toFixed(2));
                setNodes(sdata.filter(s => s !== undefined));
            }
        } else {
            setNodes([]);
            setLocalProg(0);
        }
    }, [props]);


    function filterByCollabIdAndRecalculateScores(data) {
        const dataClone = JSON.parse(JSON.stringify(data));
        function recurse(elements) {
            return elements.map(element => {
                if (element && element.children && element.children.length > 0) {
                    element.children = recurse(element.children);
                    const totalCoef = element.children.reduce((acc, child) => acc + child.coef, 0);
                    const weightedSum = element.children.reduce((acc, child) => acc + (child.progress * child.coef), 0);
                    const averageProgress = totalCoef > 0 ? weightedSum / totalCoef : 0;
                    element.progress = averageProgress;
                }
                return element;
            }).filter(element => element !== null);
        }
        return recurse(dataClone);
    }

    const nodeTemplate = (node) => {
        const color = getColor(node.progress);

        const valueDisplay = (value) => {
            if (value < 10) {
                return;
            }
            return (
                <div className="w-100" style={{ fontSize: '0.75rem', fontWeight: 600, letterSpacing: '-0.02em' }}>
                    {parseFloat(value).toFixed(1)}%
                </div>
            );
        };

        return (
            <div className="node-container row" style={{ height: 'fit-content', alignItems: 'center' }}>
                <Col lg={5} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151', letterSpacing: '-0.01em' }}>
                        {node.label}
                    </span>
                    {node.aspect === 'theoretical' && (
                        <span style={{
                            fontSize: '0.65rem',
                            fontWeight: 700,
                            color: '#6366f1',
                            background: 'rgba(99, 102, 241, 0.08)',
                            padding: '2px 6px',
                            borderRadius: '5px',
                            letterSpacing: '0.02em',
                        }}>[T]</span>
                    )}
                    {node.aspect === 'practical' && (
                        <span style={{
                            fontSize: '0.65rem',
                            fontWeight: 700,
                            color: ORANGE,
                            background: 'rgba(255, 144, 21, 0.08)',
                            padding: '2px 6px',
                            borderRadius: '5px',
                            letterSpacing: '0.02em',
                        }}>[P]</span>
                    )}
                </Col>
                <Col lg={1}>
                    {node.progress < 10 && (
                        <span style={{ fontSize: '0.75rem', fontWeight: 500, color: '#9ca3af' }}>
                            {parseFloat(node.progress).toFixed(2)}%
                        </span>
                    )}
                </Col>
                <Col lg={6} className="pe-3 ps-0">
                    <Col lg={12}>
                        <ProgressBar
                            color={color}
                            displayValueTemplate={valueDisplay}
                            showValue={true}
                            value={node.progress}
                            style={{ height: '10px', borderRadius: '6px' }}
                        />
                    </Col>
                </Col>
            </div>
        );
    };

    function body() {
        return (
            <Box className={styles.progressTreeCard}>
                {/* Tree actions header */}
                <Box className={styles.progressTreeActions}>
                    <Typography className={styles.progressTreeActionsLabel}>
                        <Langs str="Categories" />
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <button className={styles.treeActionBtn} onClick={expandAll}>
                            <i className="pi pi-angle-double-down" style={{ marginRight: 4 }} />
                            <Langs str="Expand All" />
                        </button>
                        <button className={styles.treeActionBtn} onClick={collapseAll}>
                            <i className="pi pi-angle-double-up" style={{ marginRight: 4 }} />
                            <Langs str="Collapse All" />
                        </button>
                    </Box>
                </Box>

                {/* Tree */}
                <Box sx={{
                    height: isMobile === 2 ? 'calc(100vh - 420px)' : 'calc(100vh - 420px)',
                    overflowY: 'auto',
                    px: 1,
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-track': { background: 'transparent' },
                    '&::-webkit-scrollbar-thumb': {
                        background: 'rgba(255, 144, 21, 0.15)',
                        borderRadius: '4px',
                    },
                }}>
                    <Tree
                        value={filterByCollabIdAndRecalculateScores(nodes)}
                        nodeTemplate={nodeTemplate}
                        filterPlaceholder="Search..."
                        expandedKeys={expandedKeys}
                        onToggle={(e) => setExpandedKeys(e.value)}
                        className="w-full md:w-30rem custom-tree border-0"
                    />
                </Box>
            </Box>
        );
    }

    const progColor = getColor(localProg);

    return (
        <Box className={styles.progressViewContainer}>
            {/* Overall progress card */}
            <Box className={styles.progressOverallCard}>
                <Box className={styles.progressOverallLabel}>
                    <span>
                        <Langs str='Overall Progress' />
                    </span>
                    <Typography
                        className={styles.progressOverallValue}
                        sx={{ color: progColor }}
                    >
                        {localProg}%
                    </Typography>
                </Box>
                <ProgressBar
                    color={progColor}
                    value={localProg}
                    showValue={localProg >= 10}
                    style={{ height: '12px', borderRadius: '8px' }}
                />
            </Box>

            {/* Tree */}
            {body()}
        </Box>
    );
}
